import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dumbbell, ShieldCheck, Smartphone, LayoutDashboard } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function Landing() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-422">
      <div className="max-w-4xl w-full text-center mb-12" data-id="element-423">
        <div className="inline-flex items-center justify-center p-3 bg-[var(--primary)] rounded-2xl text-white mb-6 shadow-lg shadow-orange-200" data-id="element-424">
          <Dumbbell size={40} data-id="element-425" />
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-[var(--secondary)] mb-4 tracking-tight" data-id="element-426">
          Iron Gym <span className="text-[var(--primary)]" data-id="element-427">Retention</span>
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-428">
          Plataforma white-label de retenção inteligente para academias de
          bairro. Onde o esforço vira reconhecimento.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl w-full" data-id="element-429">
        {/* Student Persona */}
        <Card className="hover:shadow-xl transition-shadow border-2 border-transparent hover:border-[var(--primary)] cursor-pointer group" onClick={() => navigate('/student/home')} data-id="element-430">
          <div className="flex flex-col items-center text-center p-6" data-id="element-431">
            <div className="bg-blue-50 p-4 rounded-full text-blue-600 mb-6 group-hover:scale-110 transition-transform" data-id="element-432">
              <Smartphone size={32} data-id="element-433" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-434">Sou Aluno</h2>
            <p className="text-gray-500 mb-8" data-id="element-435">
              Acompanhe seu progresso, veja sua constância e entre para o Hall
              da Fama.
            </p>
            <Button className="w-full" data-id="element-436">Entrar no App</Button>
          </div>
        </Card>

        {/* Admin Persona */}
        <Card className="hover:shadow-xl transition-shadow border-2 border-transparent hover:border-[var(--secondary)] cursor-pointer group" onClick={() => navigate('/admin/dashboard')} data-id="element-437">
          <div className="flex flex-col items-center text-center p-6" data-id="element-438">
            <div className="bg-gray-100 p-4 rounded-full text-gray-700 mb-6 group-hover:scale-110 transition-transform" data-id="element-439">
              <LayoutDashboard size={32} data-id="element-440" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-441">
              Sou Gestor
            </h2>
            <p className="text-gray-500 mb-8" data-id="element-442">
              Monitore riscos de churn, gerencie o Hall da Fama e recupere
              alunos.
            </p>
            <Button variant="secondary" className="w-full" data-id="element-443">
              Acessar Painel
            </Button>
          </div>
        </Card>
      </div>

      <div className="mt-16 flex items-center gap-2 text-gray-400 text-sm" data-id="element-444">
        <ShieldCheck size={16} data-id="element-445" />
        <span data-id="element-446">Ambiente Seguro de Demonstração</span>
      </div>
    </div>;
}